import { Dialog, DialogContent } from "@/components/ui/dialog";

interface VideoModalProps {
  vimeoId: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const VideoModal = ({ vimeoId, open, onOpenChange }: VideoModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-[90vw] p-0 border-none bg-black overflow-hidden [&>button]:text-white [&>button]:z-10">
        <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
          {vimeoId && (
            <iframe
              src={`https://player.vimeo.com/video/${vimeoId}?autoplay=1&title=0&byline=0&portrait=0&dnt=1`}
              className="absolute inset-0 w-full h-full"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              title="Video player"
            />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default VideoModal;
